'use client'

import HeroBanner from './components/HeroBanner'
import Overview from './components/Overview/Overview'

export default function TrustCenter() {
  return (
    <>
      <HeroBanner />
      <Overview />
    </>
  )
}
